import http from "@/utils/http";
import { Message } from "@arco-design/web-react";

// 创建自定义配音
export const createVoiceApi = async (
  data,
) => {
  try {
    const res = await http.post("/api/v1/editing/voice/custom_voice", data);
    return res.data;
  } catch (err) {
    Message.error(err);
    return Promise.reject(err);
  }
};
//
export const retryVoiceApi = async (
  data,
) => {
  try {
    const res = await http.post("/api/v1/editing/voice/custom_voice/retry", data);
    return res.data;
  } catch (err) {
    Message.error(err);
    return Promise.reject(err);
  }
};
// 查询配音列表
export const getVoiceListApi = async () => {
  try {
    const res = await http.get("/api/v1/editing/voice/list");
    return res.data;
  } catch (err) {
    Message.error(err);
    return Promise.reject(err);
  }
};
// 试听
export const getVoiceListenApi = async (data) => {
  try {
    const res = await http.post("/api/v1/editing/voice/custom_voice/preview", data);
    return res.data;
  } catch (err) {
    Message.error(err);
    return Promise.reject(err);
  }
};
// 重命名
export const renameVoiceApi = async (
  data,
) => {
  try {
    const res = await http.put(`/api/v1/editing/voice/${data.id}`, {name: data.name});
    return res.data;
  } catch (err) {
    Message.error(err);
    return Promise.reject(err);
  }
}
// 查询克隆次数
export const getVoiceTimesApi = async () => {
  try {
    const res = await http.get('/api/v1/editing/voice/custom_voice/times');
    return res.data;
  } catch (err) {
    Message.error(err);
    return Promise.reject(err);
  }
}
// 查询克隆的状态
export const getVoiceStatusApi = async (params) => {
  try {
    const res = await http.get(`/api/v1/editing/voice/custom_voice/status?speaker_id=${params.speaker_id}`);
    return res.data;
  } catch (err) {
    return Promise.reject(err);
  }
}